export { default, type Props } from "@decocms/apps-blog/sections/blocks/Callout";

// blog/sections/Template.tsx (this app's own post-content renderer) only
// looks up nested content blocks via getSyncComponent() — no lazy/Suspense
// fallback for those, unlike top-level page sections. `sync` makes the
// generator put this in syncComponents (both client and server), matching
// what Template.tsx's renderSection() requires.
export const sync = true;
